import {Component, OnDestroy, OnInit} from "@angular/core";
import {Website} from "../../website";
import {EcommerceService} from "../ecommerce.service";
import {ActivatedRoute} from "@angular/router";


@Component({
    selector: 'db-ecommerce-emails',
    templateUrl: './ecommerce-emails.component.html',
    styleUrls: ['./ecommerce-emails.component.scss'],
    standalone: false
})
export class EcommerceEmailsComponent implements OnInit, OnDestroy {

  public website: Website;
  public loading: boolean;
  public activeTab: string = 'emailList';

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _ecommerceService: EcommerceService
  ) {
  }

  ngOnInit() {
    this.website = this._activatedRoute.snapshot.parent.parent.data['website'];
  }

  ngOnDestroy() {

  }

  public setTabChange($event): void {
    this.activeTab = $event.tabId;
  }

}
